import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="sso-loading-spinner">
      <img
        src="/assets/Website-build/img/loading-spinner.png"
        alt="Loading..."
      />
    </div>
  );
};
export default LoadingSpinner;
